import styled from 'styled-components'

export const Container = styled.div`
	min-height: 80vh;
	display: flex;
	flex-direction: column;

	> h1 {
		margin-left: 80px;
		font-size: 18px;
	}
`
